module.exports = __webpack_public_path__ + "assets/img/143ff510a08609f236e1faa0171227c2.png";